export default {
  'internet explorer': '>9',
  chrome: '>50',
  firefox: '>53',
  edge: '>14',
  safari: '>9.1',
  opera: '>37'
}
